function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
import "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";
import { html as l } from "../../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";
import "../../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";
import "../input-label/input-label.gator.js";
import "../help-text/help-text.gator.js";
import { customElement as f } from "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/custom-element.js";
import { property as o } from "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/property.js";
import { state as n } from "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/state.js";
import { createRef as c, ref as v } from "../../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/directives/ref.js";
import { NgcInputBase as y } from "../../base/input-base.gator.js";
import { ifDefined as u } from "../../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/directives/if-defined.js";
import { live as m } from "../../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/directives/live.js";
import { classMap as $ } from "../../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/directives/class-map.js";
var b = Object.defineProperty,
  g = Object.getOwnPropertyDescriptor,
  i = function i(t, a, s, p) {
    for (var r = p > 1 ? void 0 : p ? g(a, s) : a, h = t.length - 1, d; h >= 0; h--) (d = t[h]) && (r = (p ? d(a, s, r) : d(r)) || r);
    return p && r && b(a, s, r), r;
  };
var e = /*#__PURE__*/function (_y) {
  function e() {
    var _this;
    _classCallCheck(this, e);
    _this = _callSuper(this, e, arguments), _this.inputRef = c(), _this.controlRef = c(), _this.for = "", _this._inputMode = "text";
    return _this;
  }
  _inherits(e, _y);
  return _createClass(e, [{
    key: "render",
    value: function render() {
      return l(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            <div class=\"gator-form-element\">\n                <slot name=\"label\">\n                    ", "\n                </slot>\n                <div ", " class=\"", "\">\n                    <div class=\"gator-input-container\">\n                        ", "\n                        <input\n                            ", "\n                            type=\"", "\"\n                            id=\"", "-input\"\n                            data-testid=", "-input\n                            .placeholder=\"", "\"\n                            .required=\"", "\"\n                            .disabled=\"", "\"\n                            ?readonly=\"", "\"\n                            class=\"gator-input\"\n                            aria-invalid=\"", "\"\n                            aria-required=\"", "\"\n                            aria-labelledby=\"", "\"\n                            aria-describedby=\"", "\"\n                            .value=\"", "\"\n                            maxlength=\"", "\"\n                            .min=\"", "\"\n                            .max=\"", "\"\n                            .step=\"", "\"\n                            inputmode=\"", "\"\n                            .pattern=\"", "\"\n                            @input=\"", "\"\n                            @change=\"", "\"\n                            @click=\"", "\"\n                            @focusin=\"", "\"\n                            @focusout=\"", "\"\n                            @invalid=\"", "\"\n                            @keydown=\"", "\"\n                            @keyup=\"", "\"\n                            @wheel=\"", "\"\n                        />\n                        <slot name=\"end-slot\">\n                            ", "\n                        </slot>\n                    </div>\n                </div>\n\n                ", "\n            </div>\n        "])), this.label && !this.iconAsLabel ? this.labelMarkup : null, v(this.controlRef), $(this.controlClasses), this.shouldHaveStartMarkup ? l(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n                                <div class=\"gator-input-start\">\n                                    ", "\n                                </div>"])), this.startIconMarkup || this._startIconAsText) : null, v(this.inputRef), this.type, this.id, u(this.dataTestid), m(this._placeholder), this.required, this.disabled, this.readonly, this.isAriaInvalid, this.required, this.ariaLabelledbyValue, this.ariaDescribedby, m(this._value), u(this._maxLength), this.min, this.max, u(this.step), this._inputMode, u(this.pattern), this.handleInputEvent, this.handleChange, this.handleClick, this.handleInputFocusIn, this.handleInputFocusOut, this.handleNativeInputValidation, this.handleKeydown, this.handleKeyup, this.handleWheel, this.shouldHaveEndMarkup ? l(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n                                    <div class=\"gator-input-end\">\n                                        ", "\n                                        ", "\n                                    </div>"])), this.passwordVisibilityMarkup, this.endIconMarkup) : null, this.bottomText);
    }
  }, {
    key: "updated",
    value: function updated(t) {
      t.has("value") && (this._value = this.value), t.has("placeholder") && (this._placeholder = this.placeholder), t.has("ariaLabelledByElements") && this.ariaLabelledByElements && (this.inputRef.value.ariaLabelledByElements = this.ariaLabelledByElements);
    }
  }, {
    key: "displayedErrorText",
    get: function get() {
      return this.errorText || this._internalValidationError || this._nativeInputError;
    }
  }, {
    key: "isAriaInvalid",
    get: function get() {
      return this.displayedErrorText ? "true" : "false";
    }
  }, {
    key: "passwordVisibilityMarkup",
    get: function get() {
      return this.endIconMarkup || this.type !== "password" ? null : l(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["<ngc-icon name=\"eye-crossed\" @click=\"", "\"></ngc-icon>"])), this.togglePasswordVisibility);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      _superPropGet(e, "connectedCallback", this, 3)([]), this._value = this.value, this._maxLength = this.maxLength, this._placeholder = this.placeholder;
    }
  }, {
    key: "handleNativeInputValidation",
    value: function handleNativeInputValidation(t) {
      this.inputRef.value && (this._nativeInputError = this.inputRef.value.validationMessage), t.preventDefault();
    }
  }, {
    key: "handleWheel",
    value: function handleWheel() {
      if (this.type == "number") {
        var _this$inputRef$value;
        (_this$inputRef$value = this.inputRef.value) === null || _this$inputRef$value === void 0 || _this$inputRef$value.blur();
        return;
      }
    }
  }, {
    key: "handleInputEvent",
    value: function handleInputEvent(t) {
      t.preventDefault(), t.stopPropagation();
      var a = t.target,
        s = new CustomEvent("input", {
          bubbles: !0,
          composed: !0,
          detail: {
            value: a.value
          }
        });
      this._value = a.value, this.dispatchEvent(s);
    }
  }, {
    key: "handleChange",
    value: function handleChange(t) {
      t.preventDefault(), t.stopPropagation();
      var a = t.target,
        s = new CustomEvent("change", {
          composed: !0,
          bubbles: !0,
          detail: {
            value: a.value
          }
        });
      this._value = a.value, this.dispatchEvent(s);
    }
  }, {
    key: "togglePasswordVisibility",
    value: function togglePasswordVisibility() {
      var t = this.inputRef.value;
      t && (t.type = t.type === "password" ? "text" : "password");
    }
  }, {
    key: "handleInputFocusOut",
    value: function handleInputFocusOut() {
      var _this$inputRef$value2;
      _superPropGet(e, "handleInputFocusOut", this, 3)([]), ((_this$inputRef$value2 = this.inputRef.value) === null || _this$inputRef$value2 === void 0 ? void 0 : _this$inputRef$value2.checkValidity()) && !this.readonly && (this._nativeInputError = "");
    }
  }, {
    key: "errorTextMarkup",
    get: function get() {
      return this.displayedErrorText ? l(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n                <ngc-help-text\n                    icon\n                    error\n                    data-testid=", "\n                    id=", "\n                >\n                    ", "\n                </ngc-help-text>\n            "])), this.errorMessageDataTestid, this.errorTextId, this.displayedErrorText) : null;
    }
  }]);
}(y);
e.shadowRootOptions = _objectSpread(_objectSpread({}, y.shadowRootOptions), {}, {
  delegatesFocus: !0
});
i([o()], e.prototype, "for", 2);
i([o({
  type: Number
})], e.prototype, "min", 2);
i([o({
  type: Number
})], e.prototype, "max", 2);
i([o({
  type: Number
})], e.prototype, "step", 2);
i([o({
  type: String
})], e.prototype, "pattern", 2);
i([n()], e.prototype, "_value", 2);
i([n()], e.prototype, "_inputMode", 2);
i([n()], e.prototype, "_placeholder", 2);
i([n()], e.prototype, "_maxLength", 2);
i([n()], e.prototype, "_errorText", 2);
i([n()], e.prototype, "_internalValidationError", 2);
i([n()], e.prototype, "_nativeInputError", 2);
e = i([f("ngc-input-text")], e);
export { e as NgcInputText };